import RfmBandFields from './rfm-band-fields';

type CardRecencyFormProps = {
  enableForm: boolean;
};

export function CardRecencyForm({ enableForm }: CardRecencyFormProps) {
  return <RfmBandFields dimension="recency" enableForm={enableForm} />;
}
